import * as React from 'react'
import { type Dayjs } from 'dayjs'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Box } from '@mui/material'

interface MaterialUIPickersProps {
  namelabel?: string
  onChange?: (newValue: Dayjs | null) => void
  value?: Dayjs | null | undefined
  disabled?: boolean
}
const MaterialUIPickers: React.FC<MaterialUIPickersProps> = (props: MaterialUIPickersProps): JSX.Element => {
  return (
    <Box width="100%">
    <LocalizationProvider dateAdapter={AdapterDayjs} >
      <DatePicker
      label={props.namelabel}
      sx={{ width: '100%' }}
      onChange={props.onChange}
      value={props.value ?? null}
      disabled={props.disabled ?? false}
      />
    </LocalizationProvider>
    </Box>
  )
}

MaterialUIPickers.defaultProps = {
  namelabel: 'Choose a date'
}

export default MaterialUIPickers
